import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Button from '../components/shared/Button.svelte';
import DatePicker from '../components/shared/DatePicker.svelte';
import { getChildById, getActiveChild, addChild, updateChild } from '../lib/stores/children.svelte.ts';
import { navigate, getSegment } from '../lib/router.svelte.ts';

var root = $.from_html(`<!> <div class="profile-page svelte-3of494bi97tmq"><div class="field svelte-3of494bi97tmq"><label for="name" class="svelte-3of494bi97tmq">Name</label> <input id="name" type="text" placeholder="e.g. Luna" class="svelte-3of494bi97tmq"/></div> <div class="field svelte-3of494bi97tmq"><label for="dob" class="svelte-3of494bi97tmq">Date of birth</label> <!></div> <div class="field svelte-3of494bi97tmq"><label for="gender" class="svelte-3of494bi97tmq">Gender (optional)</label> <select id="gender" class="svelte-3of494bi97tmq"><option>Prefer not to say</option><option>Girl</option><option>Boy</option><option>Other</option></select></div> <!></div>`, 1);

function Profile($$anchor, $$props) {
	$.push($$props, true);

	// Route: /profile        → edit active child
	// Route: /profile/new    → add a new child
	// Route: /profile/<id>   → edit a specific child
	const segment = $.derived(() => getSegment(1));

	const isNew = $.derived(() => $.get(segment) === 'new');

	const editChild = $.derived(() => !$.get(isNew)
		? $.get(segment) ? getChildById($.get(segment)) : getActiveChild()
		: null);

	let name = $.state('');
	let dob = $.state('');
	let gender = $.state('');

	$.user_effect(() => {
		$.set(name, $.get(editChild)?.name ?? '', true);

		$.set(
			dob,
			$.get(editChild)?.dateOfBirth
				? new Date($.get(editChild).dateOfBirth).toISOString().split('T')[0]
				: '',
			true
		);

		$.set(gender, $.get(editChild)?.gender ?? '', true);
	});

	async function handleSave() {
		const dobMs = $.get(dob) ? new Date($.get(dob)).getTime() : Date.now();

		if ($.get(isNew) || !$.get(editChild)) {
			await addChild({
				name: $.get(name).trim(),
				dateOfBirth: dobMs,
				gender: $.get(gender) || undefined
			});
		} else {
			await updateChild($.get(editChild).id, {
				name: $.get(name).trim(),
				dateOfBirth: dobMs,
				gender: $.get(gender) || undefined
			});
		}

		navigate('/more/children');
	}

	var fragment = root();
	var node = $.first_child(fragment);

	{
		let $0 = $.derived(() => $.get(isNew) ? 'Add child' : 'Edit child');

		TopBar(node, {
			get title() {
				return $.get($0);
			},
			showBack: true,
			backPath: '/more/children'
		});
	}

	var div = $.sibling(node, 2);
	var div_1 = $.child(div);
	var input = $.sibling($.child(div_1), 2);

	$.remove_input_defaults(input);
	$.reset(div_1);

	var div_2 = $.sibling(div_1, 2);
	var node_1 = $.sibling($.child(div_2), 2);

	DatePicker(node_1, {
		id: 'dob',
		get value() {
			return $.get(dob);
		},
		onchange: (v) => $.set(dob, v, true),
		placeholder: 'Select date of birth'
	});

	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);
	var select = $.sibling($.child(div_3), 2);
	var option = $.child(select);

	option.value = option.__value = '';

	var option_1 = $.sibling(option);

	option_1.value = option_1.__value = 'female';

	var option_2 = $.sibling(option_1);

	option_2.value = option_2.__value = 'male';

	var option_3 = $.sibling(option_2);

	option_3.value = option_3.__value = 'other';
	$.reset(select);
	$.reset(div_3);

	var node_2 = $.sibling(div_3, 2);

	{
		let $0 = $.derived(() => !$.get(name).trim());

		Button(node_2, {
			variant: 'primary',
			fullWidth: true,
			onclick: handleSave,
			get disabled() {
				return $.get($0);
			},

			children: ($$anchor, $$slotProps) => {
				$.next();

				var text = $.text();

				$.template_effect(() => $.set_text(text, $.get(isNew) ? 'Add child' : 'Save'));
				$.append($$anchor, text);
			},
			$$slots: { default: true }
		});
	}

	$.reset(div);
	$.bind_value(input, () => $.get(name), ($$value) => $.set(name, $$value));
	$.bind_select_value(select, () => $.get(gender), ($$value) => $.set(gender, $$value));
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Profile = $.hmr(Profile);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3of494bi97tmq');
		Profile[$.HMR].update(module.default);
	});
}

export default Profile;
import "bun-svelte:Profile.svelte-n3b24ix25ei2-style.css";